/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContactLock = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10zM9 7a3 3 0 1 1 6 0 3 3 0 0 1-6 0zM5 21c0-1.417.48-2.616 1.502-3.48C7.547 16.64 9.285 16 12 16c.632 0 1.212.035 1.742.099l.522-1.948A15.909 15.909 0 0 0 12 14c-3 0-5.261.704-6.788 1.992C3.664 17.3 3 19.1 3 21v1h2zm14.5-5c.887 0 1.333.587 1.333 1v1h-2.666v-1c0-.413.446-1 1.333-1zm3.333 2v-1c0-1.796-1.642-3-3.333-3s-3.333 1.204-3.333 3v1H15v6h9v-6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgContactLock as ContactLock };
